export type textProps = {
    productId: string;
    variantId: string;
    title: string;
    desc: string;
    saving: string;
    power: string;
    powerSuffix: string;
    efficiency: string;
    efficiencySuffix: string;
    link: string;
};

export const conf: Record<string, textProps[]> = {
    us: [
        {
            productId: '15311549005897',
            variantId: '54376088010825',
            title: 'STREAM Microinverter',
            desc: '2 × 400W Rigid Solar Panels\nSTREAM Microinverter 800W',
            saving: 'Saving Bills: €127',
            power: '798kWh',
            powerSuffix: 'electricity generated',
            efficiency: '23%',
            efficiencySuffix: 'Solar Panel Conversion',
            link: 'https://us.ecoflow.com/products/stream-microinverter?variant=54376088010825',
        },
        {
            productId: '15311549005897',
            variantId: '54376091975753',
            title: 'STREAM Microinverter + 2 × 400W Rigid Solar Panels',
            desc: '2 × 450W Rigid Solar Panels\nSTREAM Microinverter 800W\n2 × Lattice Balcony Brackets',
            saving: 'Saving Bills: €137',
            power: '858kWh',
            powerSuffix: 'electricity generated',
            efficiency: '23%',
            efficiencySuffix: 'Solar Panel Conversion',
            link: 'https://us.ecoflow.com/products/stream-microinverter?variant=54376091975753',
        },
        {
            productId: '15311549005897',
            variantId: '54376092008521',
            title: 'STREAM Microinverter + 4 × 400W Rigid Solar Panels',
            desc: '2 × 520W Rigid Solar Panels\nSTREAM Microinverter 800W\n2 × Garden/Flat Roof Brackets',
            saving: 'Saving Bills: €137',
            power: '858kWh',
            powerSuffix: 'electricity generated',
            efficiency: '23%',
            efficiencySuffix: 'Solar Panel Conversion',
            link: 'https://us.ecoflow.com/products/stream-microinverter?variant=54376092008521',
        },
    ],
};
